import React from 'react';
import DuperbrowseStreamContextProvider from './DuperbrowseStreamContextProvider';
import { DuperbrowseNormalizedItem } from './redux/types';

export interface Props {
  streamId: string;
  isLoadMoreAllowed?: boolean;
  streamItemSelector?: (state: any, streamId: string) => DuperbrowseNormalizedItem[];

  parent?: {
    title?: string;
    typeId?: number;
    itemId?: number;
  };
}

const LoadableDeviationDuperbrowseContext: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  streamId,
  parent,
  isLoadMoreAllowed,
  streamItemSelector,
}) => {
  return (
    <DuperbrowseStreamContextProvider
      stream={{
        streamId,
        parent,
        enableLoader: isLoadMoreAllowed,
        streamItemSelector,
        itemSchema: 'deviation',
      }}
    >
      {children}
    </DuperbrowseStreamContextProvider>
  );
};
LoadableDeviationDuperbrowseContext.displayName = 'LoadableDeviationDuperbrowseContext';

export default LoadableDeviationDuperbrowseContext;
